import React, { FC } from 'react';
import classNames from 'classnames';

import type { ControlButtonType } from '@/shared/types/notifications';

import { ControlButtonIcon } from './ControlButtonIcon';
import styles from './ControlButton.module.css';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    buttonType?: ControlButtonType;
    adButtonText?: string;
}

export const ControlButton: FC<Props> = ({
    className,
    buttonType = 'close',
    onClick = () => undefined,
    adButtonText,
    ...props
}) => (
    <button
        className={classNames(
            styles.root,
            {
                [styles.adButton]: buttonType === 'ad',
            },
            className
        )}
        type="button"
        onClick={onClick}
        data-tid={buttonType === 'close' ? 'CloseButton' : 'ControlButton'}
        {...props}
    >
        <ControlButtonIcon buttonType={buttonType} adButtonText={adButtonText} />
    </button>
);
